import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { verifyOTP } from "../../services/VerifyOTP"; // Assuming you have a service for OTP verification
import { useDocumentTitle } from "../../hooks/customDocumentTitleHook";
import classNames from "classnames";
import { notify, setSecureData } from "../../helpers";
import { Loader } from "lucide-react";
import { useSelector } from "react-redux";
import { verifyOtp } from "../../services/login";
import Spacing from "../Spacing";
import { setAccessToken, setRefreshToken } from "../../Session";

export default function VerifyOtp() {
  const navigate = useNavigate();
  let [otp, setOtp] = useState("");
  const [validateInput, setValidateInput] = useState(false);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const data = useSelector((state) => state.user)
  const handleChangeOTP = (e) => {
    setOtp(e.target.value);
  };
  const now = new Date();
  const currentYear = now.getFullYear();

  const handleVerifyOTP = async (e) => {
    e.preventDefault();
    if (otp === "") {
      setValidateInput(true);
      return;
    }
    setLoading(true);
    otp = {
      otp_code: otp,
      username:data.username,
      password:data.password
    }
    try {
      const { data } = await verifyOtp(otp );
      setLoading(false);
      await setSecureData("accessToken", data?.access_token);
      await setSecureData("refreshToken", data?.refresh_token);
      setAccessToken(data?.access_token);
      setRefreshToken(data?.refresh_token);

      navigate("/");
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errorMessage ||
        error?.response?.data?.detail ||
        error?.response?.data?.message ||
        "Oops! Server throws error";
      notify("error", errorMessage, 5);
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const searchParams = new URLSearchParams(location.search);
      const otpAuth = searchParams.get("auth");

      if (otpAuth) {
        setLoading(true);
        AuthDecodeFunc(otpAuth);
      }
    };

    fetchData();
  }, [location.search]);

  const AuthDecodeFunc = async (otpAuth) => {
    try {
      const decodedString = atob(otpAuth);
      const [auth_otp] = decodedString.split(',');

      if (auth_otp !== undefined) {
        setOtp(auth_otp);
        setValidateInput(true);

        // try {
        //   const { data } = await verifyOTP({ otp: auth_otp });
        //   await setSecureData("accessToken", data?.access_token);
        //   await setSecureData("refreshToken", data?.refresh_token);
        //   setAccessToken(data?.access_token);
        //   setRefreshToken(data?.refresh_token);
        //   navigate("/");
        // } catch (error) {
        //   const errorMessage =
        //     error?.response?.data?.errorMessage ||
        //     error?.response?.data?.detail ||
        //     error?.response?.data?.message ||
        //     "Oops! Server throws error";
        //   notify("error", errorMessage, 5);
        // }

      }
    } catch (e) { }
    setLoading(false);
  };

  useDocumentTitle("Verify OTP");

  return (
    <div className="docpro_login_wrap">
      <div
        className="docpro_login_thumb"
        style={{ backgroundImage: "url(/images/login_img.png)" }}
      ></div>
      <div className="docpro_login_right">
        <div className="docpro_login_card_wrap">
          <div className="docpro_login_card">
            <div className="docpro_text_center">
              <img src="/images/logo_2.svg" alt="Logo" />
              <Spacing lg="32" sm="32" />
              <h1 className="docpro_mb_0">Verify OTP Code</h1>
            </div>
            <Spacing lg="20" sm="20" />

            <form onSubmit={handleVerifyOTP}>
              <label className="docpro_fw_500 docpro_primary_color">
                Enter OTP
              </label>
              <input
                type="text"
                className={classNames("docpro_form_field size_lg", {
                    danger_alert: validateInput && otp === "",
                })}
                placeholder="Enter 6-digit OTP"
                name="otp"
                value={otp}
                onChange={handleChangeOTP}
                maxLength={6}
                pattern="\d{6}"
                title="OTP should be 6 digits"
              />
              <Spacing lg="20" sm="20" />

              <button
                className={`width_100 docpro_bordered_btn docpro_fw_600 docpro_filed_btn size_lg`}
                style={{ pointerEvents: `${loading ? "none" : "initial"}` }}
                type="submit"
              >
                Verify OTP
                {loading && (
                  <span className="docpro_loading">
                    <Loader width={20} height={20} />
                  </span>
                )}
              </button>
            </form>
            <Spacing lg="16" sm="16" />
          </div>
        </div>
        <footer className="docpro_login_footer">
          <div className="docpro_login_footer_nav">
            <Link to="/">Privacy policy</Link>
            <Link to="/">Terms & conditions</Link>
            <Link to="/">Terms of service</Link>
            <Link to="/">HIPAA Compliance</Link>
          </div>
          <p>© {currentYear} DocPro. All rights reserved.</p>
        </footer>
      </div>
    </div>
  );
}
